module.exports = __webpack_public_path__ + "img/729.5a446679.jpg";